import React, { useEffect, useState } from "react";
import ModalReserveMobile from "./ModalReserveMobile";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { venueService } from "services/venueService";
import { CalculateVenuePrice } from "types/venue";
import { clearPrice, setPrice } from "store/apps/price";
import moment from "moment";
import { convertHoursToDays } from "utils/convertHoursToDisplayString";

const { REACT_APP_DEFAULT_VENUE_ID } = process.env;

const MobileFooterSticky = () => {
  const { user } = useSelector((state: RootState) => state.auth);

  const { startTime, endTime, totalPrice, discountedPrice, totalHours, pointUsed, voucher } = useSelector((state: RootState) => state.price);

  const [isLoading, setIsLoading] = useState(false);

  const _onLogin = () => {};

  const dispatch = useDispatch();

  useEffect(() => {
    (async function () {
      try {
        if (!startTime || !endTime) return;

        const data: CalculateVenuePrice = {
          venue_id: Number(REACT_APP_DEFAULT_VENUE_ID),
          dateTime: {
            start_date_time: moment(startTime).format("YYYY-MM-DD HH:mm:ss"),
            end_date_time: moment(endTime).format("YYYY-MM-DD HH:mm:ss"),
          },
        };

        const res = await venueService.calculateVenuePriceByDateTime(data);

        const discount = await venueService.getVenueBookingDisountedPrice(data, pointUsed, {
          vocuher_id: voucher?.["voucher"]?.["voucher_id"],
          quantity: voucher?.["appliedCount"],
        });

        dispatch(
          setPrice({
            totalPrice: res,
            discountedPrice: discount,
          })
        );
      } catch (error) {
        dispatch(clearPrice());
      }
    })();
  }, [startTime, endTime, pointUsed, voucher]);

  const { t } = useTranslation();

  if (!user) {
    return (
      <div className="block lg:hidden fixed bottom-0 inset-x-0 py-2 sm:py-3 bg-white dark:bg-neutral-800 border-t border-neutral-200 dark:border-neutral-6000 z-40">
        <div className="container flex items-center justify-between">
          <div className="">
            <div className="flex">
              <i className={`text-xl text-neutral-500 mr-2 las la-info-circle`}></i>
              <span className="block text-sm text-neutral-500 ml-2 mr-2">{t("footer_alert_login")}</span>
            </div>
          </div>
          <ModalReserveMobile
            renderChildren={({ openModal }) => (
              <ButtonPrimary sizeClass="px-5 sm:px-7 py-3 !rounded-2xl" href="/login">
                {t("footer_login_now")}
              </ButtonPrimary>
            )}
          />
        </div>
      </div>
    );
  }

  if (!startTime || !endTime) {
    return (
      <div className="block lg:hidden fixed bottom-0 inset-x-0 py-2 sm:py-3 bg-white dark:bg-neutral-800 border-t border-neutral-200 dark:border-neutral-6000 z-40">
        <div className="container flex items-center justify-between">
          <div className="">
            <div className="flex">
              <i className={`text-xl text-neutral-500 mr-2 las la-info-circle`}></i>
              <span className="block text-sm text-neutral-500 ml-2 mr-2">{t("footer_alert_select_time")}</span>
            </div>
          </div>
          <div className="px-5 sm:px-7 py-5 !rounded-2xl"></div>
          {/* <ModalReserveMobile
            renderChildren={({ openModal }) => (
              <ButtonPrimary sizeClass="px-5 sm:px-7 py-3 !rounded-2xl" href="/login">
                立即登入
              </ButtonPrimary>
            )}
          /> */}
        </div>
      </div>
    );
  }

  return (
    <div className="block lg:hidden fixed bottom-0 inset-x-0 py-2 sm:py-3 bg-white dark:bg-neutral-800 border-t border-neutral-200 dark:border-neutral-6000 z-40">
      <div className="container flex items-center justify-between">
        <div className="">
          {discountedPrice !== totalPrice ? (
            <span className="block text-xl font-semibold">
              <span className="line-through text-sm text-neutral-500">${totalPrice || 0}</span>
              <span className="ml-2 text-xl text-primary-500">${discountedPrice || 0}</span>
              <span className="ml-1 text-sm font-normal text-neutral-500 dark:text-neutral-400">/ {convertHoursToDays(totalHours)}</span>
            </span>
          ) : (
            <span className="block text-xl font-semibold">
              ${totalPrice || 0}
              <span className="ml-1 text-sm font-normal text-neutral-500 dark:text-neutral-400">/ {convertHoursToDays(totalHours)}</span>
            </span>
          )}

          <div className="flex">
            <i className={`text-xl text-neutral-500 mr-2 las la-calendar`}></i>
            <span className="block text-sm text-neutral-500 ">{moment(startTime).format("YY/MM/DD HH:mm")}</span>
            <span className="block text-sm text-neutral-500 ml-2 mr-2"> - </span>
            <span className="block text-sm text-neutral-500">{moment(endTime).format("YY/MM/DD HH:mm")}</span>
          </div>
        </div>
        <ModalReserveMobile
          renderChildren={({ openModal }) => (
            <ButtonPrimary sizeClass="px-5 sm:px-7 py-3 !rounded-2xl" onClick={openModal}>
              {t("reserve")}
            </ButtonPrimary>
          )}
        />
      </div>
    </div>
  );
};

export default MobileFooterSticky;
